import { SelectSearchableVariant } from '@hse-design/core';
import { __extends, __assign, __decorate, __metadata } from 'tslib';
import { Prop, Component, Vue } from 'vue-property-decorator';
import { EnumProp } from '../../utils/enumProp.js';
import __vue_component__ from '../HseInput/HseInput.vue.js';
import merge from 'lodash/merge';

var HseSelectSearchInput = /** @class */ (function (_super) {
    __extends(HseSelectSearchInput, _super);
    function HseSelectSearchInput() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HseSelectSearchInput.prototype.refInput = function () {
        var _a;
        return this.$refs.input || ((_a = this.$refs.hseInput) === null || _a === void 0 ? void 0 : _a.$refs.input);
    };
    HseSelectSearchInput.prototype.render = function (h) {
        var props = __assign(__assign(__assign({}, this.$attrs), this.$props), { tabIndex: !this.$attrs.disabled ? 0 : -1 });
        var commonData = {
            on: this.$listeners,
            staticClass: 'hse-Select__searchInput',
        };
        if (this.type === SelectSearchableVariant.dropdown) {
            return h(__vue_component__, merge(commonData, { ref: 'hseInput', props: props }));
        }
        return h('input', merge(commonData, { ref: 'input', attrs: props, class: ['hse-Select__searchInput', 'hse-Select__searchInput_noBorder', 'hse-Select__searchInput_inline'] }));
    };
    __decorate([
        Prop(EnumProp(SelectSearchableVariant.inline, SelectSearchableVariant)),
        __metadata("design:type", String)
    ], HseSelectSearchInput.prototype, "type", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", String)
    ], HseSelectSearchInput.prototype, "value", void 0);
    HseSelectSearchInput = __decorate([
        Component({
            name: 'HseSelectSearchInput'
        })
    ], HseSelectSearchInput);
    return HseSelectSearchInput;
}(Vue));

export default HseSelectSearchInput;
